import script from "./QuoteSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./QuoteSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./QuoteSkeleton.vue?vue&type=style&index=0&id=0ff682b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ff682b8"]])

export default __exports__